import { useMemo } from "react";
import { useFormContext, useFormState } from "react-hook-form";

/**
 * Whether the estimate can be created or saved right now — the same condition
 * that disables the footer's actions, so the footer's hint text and the buttons
 * can never disagree.
 */
export function useOrderReadiness(): boolean {
  const { getValues, watch } = useFormContext();
  const { isValid } = useFormState();
  const procedures = watch("serviceDetails");
  const isEditingMessage = watch("isEditingMessage");

  return useMemo(() => {
    const hasEmptyCptDescription = getValues()?.serviceDetails?.some(
      (procedure: any) => !procedure.cptDescription.trim().length
    );

    return (
      isValid &&
      !!procedures?.length &&
      !hasEmptyCptDescription &&
      !isEditingMessage
    );
  }, [getValues, isValid, procedures, isEditingMessage]);
}
